import { useContext } from 'react';
import { StepUpContext } from './StepUpContext';

export function useStepUp() {
  const ctx = useContext(StepUpContext);
  if (!ctx) {
    throw new Error('useStepUp must be used within StepUpProvider');
  }
  return ctx;
}
